"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Countdown = _interopRequireDefault(require("./Countdown"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var defaultCount = 3;
var defaultDelay = 800;
var CountdownTimer = /*#__PURE__*/function (_react$default$PureCo) {
  function CountdownTimer() {
    var _this;
    _classCallCheck(this, CountdownTimer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CountdownTimer, [].concat(args));
    _defineProperty(_this, "state", {});
    return _this;
  }
  _inherits(CountdownTimer, _react$default$PureCo);
  return _createClass(CountdownTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        _this$props$count = _this$props.count,
        count = _this$props$count === void 0 ? defaultCount : _this$props$count,
        _this$props$delay = _this$props.delay,
        delay = _this$props$delay === void 0 ? defaultDelay : _this$props$delay,
        onFinish = _this$props.onFinish;
      var self = this;
      this.setState({
        count: count
      }, function () {
        var counter = setInterval(function () {
          var newCount = self.state.count - 1;
          if (newCount === 0) {
            clearInterval(counter);
            onFinish();
          } else {
            self.setState({
              count: newCount
            });
          }
        }, delay);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        size = _this$props2.size,
        _this$props2$count = _this$props2.count,
        propsCount = _this$props2$count === void 0 ? defaultCount : _this$props2$count;
      var count = this.state.count;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: size,
          height: size
        },
        className: "countDown"
      }, /*#__PURE__*/_react.default.createElement(_Countdown.default, {
        time: count ? count - 1 : propsCount
      }));
    }
  }]);
}(_react.default.PureComponent);
var _default = exports.default = CountdownTimer;